
/* bara: miscata din JS, nu din CSS, ca sa mearga si cu animatiile oprite din sistem */
(function(){
  var items = ['13 VOCAL CHAINS','FL STUDIO 21+','STOCK PLUGINS ONLY','INSTANT DOWNLOAD','CODE LAW10 = 10% OFF'];
  var tracks = [document.getElementById('track'), document.getElementById('track2')].filter(Boolean);
  if (!tracks.length) return;
  var html = '';
  for (var pass = 0; pass < 4; pass++){
    for (var i = 0; i < items.length; i++){
      html += '<span class="item">' + items[i] + '</span><span class="item dot">&bull;</span>';
    }
  }
  tracks.forEach(function(t){ if(t) t.innerHTML = html; });

  var x = 0, half = 0, last = 0;
  var SPEED = 45; /* px/secunda, de la stanga la dreapta */
  function measure(){ var t = tracks[0]; if (!t) return; half = t.scrollWidth / 2; x = -half; }
  measure();
  window.addEventListener('resize', measure);

  function frame(now){
    if (!last) last = now;
    var dt = (now - last) / 1000;
    last = now;
    if (dt > 0.25) dt = 0.016;
    x += SPEED * dt;
    if (x >= 0) x -= half;
    var tr = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
    tracks.forEach(function(t){ if(t) t.style.transform = tr; });
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();

/* inelul de lumina de pe card, tot din JS */
(function(){
  var cards = document.querySelectorAll('.card.buy');
  var deg = 0;
  function spin(){
    deg = (deg + 1.5) % 360;
    for (var i = 0; i < cards.length; i++){
      cards[i].style.setProperty('--a', deg + 'deg');
    }
    requestAnimationFrame(spin);
  }
  requestAnimationFrame(spin);
})();

function pick(btn, src){
  document.getElementById('stageImg').src = src;
  var all = document.querySelectorAll('.th');
  for (var i = 0; i < all.length; i++) all[i].classList.remove('on');
  btn.classList.add('on');
}
function copyCode(){
  try { navigator.clipboard.writeText('LAW10'); } catch (e) {}
  var c = document.getElementById('copied');
  if (!c) return;
  var btn = c.closest('.ocopy');
  c.textContent = 'Copied';
  if (btn) btn.classList.add('done');
  setTimeout(function(){
    c.textContent = 'Copy Code';
    if (btn) btn.classList.remove('done');
  }, 1800);
}

/* ---- hero: intrare + breathing glow doar pe titlu ---- */
(function(){
  var sig = document.getElementById('hSig'), wm = document.getElementById('hWm');
  var bad = document.getElementById('hBadge');
  var l1 = document.getElementById('hL1'), cta = document.getElementById('hCta');
  var lede = document.getElementById('hLede');
  var halo = document.getElementById('heroHalo');
  /* wordmark-ul din hero a fost scos; animatia porneste de la titlu */
  if (!l1) return;

  var items = [];
  if (sig) items.push({el: sig, delay: 60,  rise: 16});
  if (wm)  items.push({el: wm,  delay: 170, rise: 16});
  if (bad) items.push({el: bad, delay: 300, rise: 18});
  if (l1)  items.push({el: l1,  delay: 400, rise: 30});
  if (lede) items.push({el: lede, delay: 560, rise: 20});
  if (cta) items.push({el: cta, delay: 680, rise: 18});

  var DUR = 900, t0 = null;
  function easeOutExpo(x){ return x >= 1 ? 1 : 1 - Math.pow(2, -10 * x); }


  function frame(now){
    if (t0 === null) t0 = now;
    var t = now - t0;

    for (var i = 0; i < items.length; i++){
      var it = items[i];
      var p = Math.min(1, Math.max(0, (t - it.delay) / DUR));
      var e = easeOutExpo(p);
      it.el.style.opacity = e.toFixed(3);
      if (p < 1) it.el.style.transform = 'translate3d(0,' + ((1 - e) * it.rise).toFixed(2) + 'px,0)';
      else if (it.el.style.transform !== 'none') it.el.style.transform = 'none';
    }

    /* doar halo-ul respira; titlul ramane curat, fara glow */
    var ph = (t % 3600) / 3600;
    var g = ph < 0.42 ? Math.pow(ph / 0.42, 0.85) : Math.pow(1 - (ph - 0.42) / 0.58, 1.5);
    var lead = Math.min(1, Math.max(0, (t - 400) / DUR));
    var gl = g * lead;
    if (halo) halo.style.opacity = (0.55 + 0.30 * gl).toFixed(3);

    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();


/* ---- help centre ---- */
var HELP_QA = [
  ["What's inside?",
   "<b>Thirteen Patcher presets</b> \u2014 3 leads (pop, rap, trap), 4 doubles and 6 adlibs. Each one is a complete chain with six macros mapped to it."],
  ["Which DAW do I need?",
   "<b>FL Studio 21 or newer.</b> Patcher is exclusive to FL, so these presets do not open in another DAW."],
  ["Do I need paid plugins?",
   "No. Every chain is built with plugins that ship with FL Studio. A pitch correction tool is the only thing you may want on top, and any one will do."],
  ["Will this make me an engineer?",
   "No preset does that \u2014 hours in front of a mixer do. What this removes is the <b>guessing</b>: the routing and the order are already right, so you spend your time on the performance instead of the wiring."],
  ["Can I edit them?",
   "Yes. Open Patcher's Map tab and every plugin is there, exactly as it was built. Nothing is hidden or locked."],
  ["Can I use them on released music?",
   "Yes. Royalty free, on commercial releases, no credit required. You may not resell or redistribute the presets themselves."],
  ["How do I get it?",
   "<b>Instant download.</b> The link lands in your inbox the moment the payment goes through."],
  ["Is there a discount?",
   "Code <b>LAW10</b> takes 10% off at checkout."]
];
(function(){
  var box = document.getElementById('helpAsks');
  if (!box) return;
  for (var i = 0; i < HELP_QA.length; i++){
    var s = document.createElement('span');
    s.className = 'ask'; s.textContent = HELP_QA[i][0];
    s.setAttribute('data-i', i);
    s.onclick = function(){ askHelp(parseInt(this.getAttribute('data-i'), 10), this); };
    box.appendChild(s);
  }
})();
function toggleHelp(){
  var h = document.getElementById('help');
  h.classList.contains('open') ? closeHelp() : openHelp();
}
function openHelp(){
  var h = document.getElementById('help');
  h.classList.add('open');
  var p = h.querySelector('.panel'), t0 = null;
  function fr(now){
    if (t0 === null) t0 = now;
    var k = Math.min(1, (now - t0) / 260), e = 1 - Math.pow(1 - k, 3);
    p.style.opacity = e.toFixed(3);
    p.style.transform = 'translate3d(0,' + ((1 - e) * 14).toFixed(1) + 'px,0)';
    if (k < 1) requestAnimationFrame(fr);
  }
  requestAnimationFrame(fr);
}
function closeHelp(){ document.getElementById('help').classList.remove('open'); }
function askHelp(i, el){
  var th = document.getElementById('helpThread');
  var q = document.createElement('p'); q.className = 'msg q'; q.textContent = HELP_QA[i][0];
  th.appendChild(q);
  el.classList.add('used');
  setTimeout(function(){
    var a = document.createElement('p'); a.className = 'msg a'; a.innerHTML = HELP_QA[i][1];
    th.appendChild(a); th.scrollTop = th.scrollHeight;
  }, 260);
  th.scrollTop = th.scrollHeight;
}


/* ---- intrarea cardurilor, in cascada, la load ---- */
(function(){
  var cards = document.querySelectorAll('#shop .grid .card');
  if (!cards.length) return;
  for (var i = 0; i < cards.length; i++){
    cards[i].style.opacity = '0';
    cards[i].style.transform = 'translate3d(0,22px,0)';
  }
  var START = 520, DUR = 760, STEP = 140, t0 = null;
  function ease(x){ return x >= 1 ? 1 : 1 - Math.pow(2, -10 * x); }
  function fr(now){
    if (t0 === null) t0 = now;
    var t = now - t0, done = true;
    for (var i = 0; i < cards.length; i++){
      var p = Math.min(1, Math.max(0, (t - START - i * STEP) / DUR));
      var e = ease(p);
      cards[i].style.opacity = (cards[i].classList.contains('locked') ? e * 0.62 : e).toFixed(3);
      if (p < 1){ cards[i].style.transform = 'translate3d(0,' + ((1 - e) * 22).toFixed(1) + 'px,0)'; done = false; }
      else cards[i].style.transform = 'none';
    }
    if (!done) requestAnimationFrame(fr);
  }
  requestAnimationFrame(fr);
})();

function openPromo(){ var el = document.getElementById('promo'); if (el) el.classList.add('open'); }
function closePromo(){ var el = document.getElementById('promo'); if (el) el.classList.remove('open'); }
function submitPromo(e){
  e.preventDefault();
  e.target.style.display = 'none';
  document.getElementById('promoOk').style.display = 'block';
  return false;
}
setTimeout(function(){
  var pel = document.getElementById('promo');
  if (pel && !pel.classList.contains('open')) openPromo();
}, 7000);
/* ============ cart drawer, in pasi ============
   Straturile vechi raman: /cart.js pentru citire, /cart/add.js si
   /cart/change.js pentru scriere. Peste ele sta o masina de pasi.
   Pasii care nu sunt configurati in editor nu exista deloc in DOM,
   deci nu trebuie sariti prin cod. */
(function () {
  var root = document.getElementById('cd');
  if (!root) return;

  var panel   = root.querySelector('.cd-panel');
  var list    = root.querySelector('.cd-items');
  var empty   = root.querySelector('.cd-empty');
  var count   = root.querySelector('.cd-count');
  var pill    = root.querySelector('.cd-pill');
  var subEl   = root.querySelector('.cd-sub');
  var totEl   = root.querySelector('.cd-total');
  var vatRow  = root.querySelector('.cd-vatrow');
  var vatL    = root.querySelector('.cd-vatl');
  var vatV    = root.querySelector('.cd-vatv');
  var form    = root.querySelector('.cd-disc');
  var input   = form ? form.querySelector('input') : null;
  var msg     = root.querySelector('.cd-msg');
  var actions = root.querySelector('[data-cd-actions]');
  var backBtn = root.querySelector('[data-cd-back]');
  var stepsEl = root.querySelector('[data-cd-steps]');
  var stepLbl = root.querySelector('[data-cd-steplbl]');
  var headH   = root.querySelector('[data-cd-h]');
  var headP   = root.querySelector('[data-cd-p]');
  var resEl   = root.querySelector('[data-cd-res]');
  var clockEl = root.querySelector('[data-cd-clock]');
  var onlyBag = root.querySelector('.cd-onlybag');

  var CUR  = root.dataset.cur || 'USD';
  var VAT  = parseFloat(root.dataset.vat || '0') || 0;
  var VATL = root.dataset.vatlabel || 'Included VAT';
  var RESERVE = parseInt(root.dataset.reserve || '0', 10) || 0;
  var TIERS = [];
  try { TIERS = JSON.parse(root.dataset.tiers || '[]'); } catch (e) {}
  TIERS = TIERS.filter(function (t) { return t && t.q > 1 && t.p > 0 && t.c; })
               .sort(function (a, b) { return a.q - b.q; });

  var busy = false, code = '', lastFocus = null, cartNow = null;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- pasii care chiar exista in pagina ---- */
  var PANES = [];
  ['daw', 'gift', 'upsell', 'bag'].forEach(function (k) {
    var el = root.querySelector('[data-pane="' + k + '"]');
    if (el) PANES.push({ key: k, el: el });
  });
  var COPY = {
    daw:    ['Pick your DAW', 'Your preset installs straight into the DAW you produce in.'],
    gift:   ['Claim your gift', 'A bonus is waiting. Tap to reveal it.'],
    upsell: ['Add one, save more', 'A second chain unlocks the bundle price.'],
    bag:    ['Your cart', '']
  };
  var at = 0, gifted = false, upAdded = false, dawPicked = '', dawSent = false;

  function money(c) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: CUR,
        minimumFractionDigits: (c % 100 === 0 ? 0 : 2) }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2); }
  }

  /* ---- treptele: raportam doar ce se poate aplica pe bune ---- */
  function tierFor(n) {
    var hit = null;
    TIERS.forEach(function (t) { if (n >= t.q) hit = t; });
    return hit;
  }
  function nextTier(n) {
    for (var i = 0; i < TIERS.length; i++) if (n < TIERS[i].q) return TIERS[i];
    return null;
  }
  function paintTiers(n) {
    var box = root.querySelector('[data-cd-tiers]');
    if (!box) return;
    if (!TIERS.length) { box.hidden = true; return; }
    box.hidden = false;
    var cur = tierFor(n), nx = nextTier(n);
    root.querySelector('[data-cd-tbig]').textContent = (cur ? cur.p : 0) + '% OFF';
    var row = root.querySelector('[data-cd-trow]');
    row.innerHTML = '';
    TIERS.forEach(function (t) {
      var d = document.createElement('div');
      d.className = 'cd-tier' + (cur && cur.q === t.q ? ' on' : '');
      d.innerHTML = '<b>' + t.p + '%</b><span>' + t.q + ' items</span>';
      row.appendChild(d);
    });
    var nt = root.querySelector('[data-cd-tnext]');
    if (nx) {
      var need = nx.q - n;
      nt.innerHTML = 'Add <b>' + need + ' more</b> to save <b>' + nx.p + '%</b>';
    } else {
      nt.textContent = cur ? 'Best price reached.' : '';
    }
    /* codul treptei atinse se aplica singur, o singura data */
    if (cur && cur.c && code.toUpperCase() !== cur.c.toUpperCase()) applyCode(cur.c, true);
  }

  /* ---- randare cos ---- */
  function render(cart) {
    cartNow = cart;
    var n = cart.item_count || 0;
    count.textContent = n;
    if (pill) pill.textContent = n + (n === 1 ? ' item' : ' items');
    document.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = n; });

    list.innerHTML = '';
    empty.hidden = n > 0;

    (cart.items || []).forEach(function (it) {
      var li = document.createElement('li');
      li.className = 'cd-it';
      var raw = (it.featured_image && it.featured_image.url) || it.image || '';
      var img = raw ? raw.split('?')[0] + '?width=180' : '';
      var sale = it.original_line_price > it.final_line_price;
      var free = it.final_line_price === 0;
      li.innerHTML =
        '<div class="cd-im">' + (img ? '<img src="' + img + '" alt="" loading="lazy">'
                                     : '<span class="cd-ph">§</span>') + '</div>' +
        '<div class="cd-in">' +
          '<div class="cd-nm">' + it.product_title + (free ? ' <em class="cd-free">free</em>' : '') + '</div>' +
          '<div class="cd-sb">' + (it.variant_title && it.variant_title !== 'Default Title'
              ? it.variant_title : 'Instant download') + '</div>' +
          '<div class="cd-ln">' +
            '<span class="cd-q2">' +
              '<button type="button" data-q="-1" aria-label="Decrease">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-q="1" aria-label="Increase">+</button>' +
            '</span>' +
            '<button type="button" class="cd-rm">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="cd-pr">' + (sale ? '<s>' + money(it.original_line_price) + '</s>' : '') +
          '<b>' + money(it.final_line_price) + '</b></div>';
      li.querySelector('.cd-rm').addEventListener('click', function () { change(it.key, 0); });
      li.querySelectorAll('[data-q]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          change(it.key, Math.max(0, it.quantity + parseInt(btn.dataset.q, 10)));
        });
      });
      list.appendChild(li);
    });

    subEl.textContent = money(cart.items_subtotal_price != null
      ? cart.items_subtotal_price : cart.original_total_price);
    totEl.textContent = money(cart.total_price);

    if (VAT > 0 && cart.total_price > 0) {
      vatRow.hidden = false;
      vatL.textContent = VATL + ' (' + VAT + '%)';
      vatV.textContent = money(Math.round(cart.total_price * VAT / (100 + VAT)));
    } else { vatRow.hidden = true; }

    paintTiers(n);
    pickUpsell();
    paintStep();
  }

  /* ---- pasii ---- */
  /* Cate produse platite sunt in cos. Cadoul nu se pune la socoteala:
     e gratuit, deci nu poate fi si motivul pentru care il primesti. */
  function paidCount() {
    if (!cartNow) return 0;
    var n = 0;
    (cartNow.items || []).forEach(function (i) {
      var p = (i.original_line_price != null) ? i.original_line_price : i.final_line_price;
      if (p > 0) n += (i.quantity || 1);
    });
    return n;
  }

  /* Pasul 3 propune primul produs care NU e deja in cos. Cardurile sunt
     toate in pagina, ascunse; il aratam pe cel potrivit. Daca omul le are
     pe toate, nu mai avem ce propune si pasul se sare. */
  function pickUpsell() {
    var pane = root.querySelector('[data-pane="upsell"]');
    if (!pane) return false;
    var cards = pane.querySelectorAll('[data-up-card]');
    if (!cards.length) return false;

    var inCart = {};
    if (cartNow) (cartNow.items || []).forEach(function (i) { inCart[String(i.variant_id)] = 1; });

    var chosen = null;
    for (var i = 0; i < cards.length; i++) {
      if (!inCart[String(cards[i].dataset.upId)]) { chosen = cards[i]; break; }
    }
    for (var k = 0; k < cards.length; k++) cards[k].hidden = (cards[k] !== chosen);
    if (!chosen) { pane.removeAttribute('data-up-id'); return false; }
    /* alt produs propus decat inainte = buton de adaugare din nou, nu Continue */
    if (pane.dataset.upId && pane.dataset.upId !== chosen.dataset.upId) upAdded = false;
    pane.dataset.upId = chosen.dataset.upId;
    return true;
  }

  function paintStep() {
    var cur = PANES[at];
    if (!cur) return;
    if (cur.key === 'upsell' && !pickUpsell() && at < PANES.length - 1) { step(1); return; }

    PANES.forEach(function (p, i) { p.el.classList.toggle('on', i === at); });
    stepsEl.innerHTML = '';
    PANES.forEach(function (p, i) {
      var s = document.createElement('i');
      if (i <= at) s.className = 'on';
      stepsEl.appendChild(s);
    });
    stepLbl.textContent = 'STEP ' + (at + 1) + ' OF ' + PANES.length;
    headH.textContent = COPY[cur.key][0];
    headP.textContent = COPY[cur.key][1];
    headP.hidden = !COPY[cur.key][1];
    backBtn.hidden = at === 0;
    if (onlyBag) onlyBag.hidden = cur.key !== 'bag';

    actions.innerHTML = '';
    function btn(txt, cls, fn) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cd-btn ' + cls; b.innerHTML = txt;
      b.addEventListener('click', fn); actions.appendChild(b); return b;
    }

    if (cur.key === 'daw') {
      var h = document.createElement('p');
      h.className = 'cd-hint';
      h.innerHTML = dawPicked ? ('DAW: <b>' + dawPicked + '</b>') : 'Tap your DAW <b>to continue</b>';
      actions.appendChild(h);
      if (dawPicked) btn('Continue &rarr;', 'dark', function () { sendDaw(); step(1); });

    } else if (cur.key === 'gift') {
      if (gifted) {
        btn('Continue &rarr;', 'dark', function () { step(1); });
      } else if (paidCount() < 1) {
        /* cadoul vine peste o comanda, nu in locul ei */
        var lk = document.createElement('p');
        lk.className = 'cd-hint';
        lk.innerHTML = 'Add a preset first &mdash; <b>the gift comes with your order</b>';
        actions.appendChild(lk);
        btn('Pick a preset &rarr;', 'dark', function () { close(); });
      } else {
        btn('&#127873;&nbsp; Claim free gift', 'go', claimGift);
        btn('No thanks, skip &rarr;', 'ghost', function () { step(1); });
      }

    } else if (cur.key === 'upsell') {
      if (!upAdded) {
        btn('+&nbsp; Add to bag', 'go', addUpsell);
        btn('No thanks, keep going &rarr;', 'ghost', function () { step(1); });
      } else {
        btn('Continue &rarr;', 'dark', function () { step(1); });
      }

    } else {
      var go = btn('Checkout securely &rarr;', 'go', checkout);
      var n = cartNow ? (cartNow.item_count || 0) : 0;
      var paid = paidCount();
      /* un cos care are doar cadoul nu e o comanda: nu lasam sa treaca */
      var block = n === 0 || paid === 0;
      go.disabled = block;
      go.style.opacity = block ? '.45' : '';
      var g = document.createElement('p');
      g.className = 'cd-guar';
      if (n > 0 && paid === 0) {
        g.innerHTML = '<span>Add a preset to check out &mdash; the gift comes with it</span>';
      } else {
        g.innerHTML = '<span>instant download</span><span>&middot;</span>' +
                      '<span>secure checkout</span>';
      }
      actions.appendChild(g);
    }
  }

  function step(d) {
    at = Math.min(PANES.length - 1, Math.max(0, at + d));
    paintStep();
    root.querySelector('.cd-body').scrollTop = 0;
  }
  backBtn.addEventListener('click', function () { step(-1); });

  /* pasul 1: DAW -> se salveaza ca atribut pe cos, il vezi in comanda.
     Daca exista un singur DAW, il bifam noi: pasul ramane vizibil, ca sa
     stie omul in ce program merge inainte sa plateasca, dar nu-i cerem un
     click care nu are alta varianta. */
  var dawBtns = root.querySelectorAll('[data-daw]');  /* doar cele care se pot alege */
  function sendDaw() {
    if (!dawPicked || dawSent) return;
    dawSent = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { DAW: dawPicked } })
    }).catch(function () { dawSent = false; });
  }
  dawBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      dawBtns.forEach(function (x) { x.classList.remove('sel'); });
      b.classList.add('sel');
      if (dawPicked !== b.dataset.daw) dawSent = false;
      dawPicked = b.dataset.daw;
      sendDaw();
      setTimeout(function () { step(1); }, 240);
    });
  });
  if (dawBtns.length === 1) {
    dawBtns[0].classList.add('sel');
    dawPicked = dawBtns[0].dataset.daw;
  }

  /* pasul 2: cadoul */
  function claimGift() {
    var pane = root.querySelector('[data-pane="gift"]');
    var id = pane && pane.dataset.giftId;
    if (!id || busy) return;
    /* plasa a doua: chiar daca butonul ar aparea din greseala, nu dam
       cadoul pe un cos fara niciun produs platit */
    if (paidCount() < 1) return;
    busy = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw 0; return load(); })
      .then(function () {
        gifted = true;
        root.querySelector('[data-cd-gift]').classList.add('won');
        var t = root.querySelector('[data-cd-gifth]');
        if (t) t.textContent = t.dataset.done || 'Gift unlocked!';
        var p = root.querySelector('[data-cd-giftp]');
        if (p) p.textContent = 'Added to your bag, free.';
        paintStep();
      })
      .catch(function () { step(1); })
      .then(function () { busy = false; });
  }

  /* pasul 3: al doilea produs */
  function addUpsell() {
    var pane = root.querySelector('[data-pane="upsell"]');
    var id = pane && pane.dataset.upId;
    if (!id || busy) return;
    busy = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw 0; return load(); })
      .then(function () { upAdded = true; step(1); })
      .catch(function () { step(1); })
      .then(function () { busy = false; });
  }

  /* ---- ceasul de rezervare ---- */
  var left = RESERVE * 60, timer = null;
  function tickClock() {
    left = Math.max(0, left - 1);
    var m = Math.floor(left / 60), s = left % 60;
    clockEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    if (left === 0 && timer) { clearInterval(timer); timer = null; }
  }
  function startClock() {
    if (!RESERVE || timer) return;
    resEl.hidden = false;
    tickClock();
    timer = setInterval(tickClock, 1000);
  }

  /* ---- deschis / inchis ---- */
  function open() {
    lastFocus = document.activeElement;
    root.classList.add('open');
    document.body.classList.add('cd-on');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    startClock();
    setTimeout(function () { var b = root.querySelector('.cd-x'); if (b) b.focus(); }, 40);
  }
  function close() {
    root.classList.remove('open');
    document.body.classList.remove('cd-on');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function load(openAfter) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); if (openAfter) open(); return c; })
      .catch(function () {});
  }

  function change(key, qty) {
    if (busy) return; busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (c) { render(c); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  /* add to cart, fara sa paraseasca pagina; cosul porneste de la primul pas */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    if (busy) return; busy = true;
    var btn = f.querySelector('[type=submit]'), label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var fd = new FormData(f);
    fd.delete('return_to');
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); at = 0; return load(true); })
      .catch(function () { f.submit(); })
      .then(function () {
        busy = false;
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  }, true);

  /* ---- cod de reducere ---- */
  function applyCode(v, quiet) {
    code = v;
    return fetch('/discount/' + encodeURIComponent(v), { redirect: 'follow' })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cartNow = c;
        totEl.textContent = money(c.total_price);
        if (quiet || !msg) return c;
        msg.hidden = false;
        if (c.total_discount > 0) {
          msg.className = 'cd-msg ok';
          msg.textContent = 'Code ' + v.toUpperCase() + ' applied, you save ' + money(c.total_discount) + '.';
        } else {
          msg.className = 'cd-msg';
          msg.textContent = 'Code ' + v.toUpperCase() + ' will be applied at checkout.';
        }
        return c;
      })
      .catch(function () {
        if (!quiet && msg) {
          msg.hidden = false; msg.className = 'cd-msg';
          msg.textContent = 'Code saved, it is applied at checkout.';
        }
      });
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (input.value || '').trim();
      if (!v) return;
      msg.hidden = false; msg.className = 'cd-msg'; msg.textContent = 'Checking…';
      applyCode(v, false);
    });
  }

  function checkout() {
    if (paidCount() < 1) return;
    window.location.href = code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
  }

  /* ---- deschizatori ---- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest ? e.target.closest('[data-cd-open]') : null;
    if (o) { e.preventDefault(); at = 0; load(true); return; }
    var c = e.target.closest ? e.target.closest('[data-cd-close]') : null;
    if (c) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('open')) close();
  });

  /* cosul traieste in drawer, niciodata pe pagina lui */
  var onCartUrl = /\/cart\/?$/.test(window.location.pathname);
  if (onCartUrl && window.history.replaceState) {
    window.history.replaceState({}, '', root.dataset.home || '/');
  }
  var wantsCart = onCartUrl || /[?&]cart=1/.test(window.location.search);
  if (wantsCart && window.history.replaceState) {
    window.history.replaceState({}, '', window.location.pathname +
      window.location.search.replace(/([?&])cart=1&?/, '$1').replace(/[?&]$/, ''));
  }
  load(wantsCart);
})();


/* ============ filtre pe categorii ============ */
(function () {
  var chips = document.querySelectorAll('.filters .chip');
  var grid  = document.querySelector('.grid');
  var count = document.getElementById('sortCount');
  if (!chips.length || !grid) return;
  var cards = grid.querySelectorAll('.card');

  function apply(cat) {
    var n = 0;
    for (var i = 0; i < cards.length; i++) {
      var show = cat === 'all' || cards[i].getAttribute('data-cat') === cat;
      cards[i].style.display = show ? '' : 'none';
      if (show) n++;
    }
    if (count) count.textContent = n + (n === 1 ? ' item' : ' items');
  }

  for (var i = 0; i < chips.length; i++) {
    (function (ch) {
      ch.addEventListener('click', function () {
        for (var j = 0; j < chips.length; j++) chips[j].classList.remove('on');
        ch.classList.add('on');
        apply(ch.getAttribute('data-cat') || 'all');
      });
    })(chips[i]);
  }
  apply('all');
})();


/* ============ bara de cumparare lipita jos (pagina de presete) ============ */
(function () {
  var bar = document.getElementById('buybar');
  if (!bar) return;
  var cta = document.querySelector('#pop .cta');
  function upd() {
    var r = cta ? cta.getBoundingClientRect() : null;
    bar.classList.toggle('show', !r || r.bottom < 0);
  }
  window.addEventListener('scroll', upd, { passive: true });
  window.addEventListener('resize', upd);
  upd();
})();


/* ---- player A/B: acelasi take, doua lanturi ----
   Cele doua fisiere merg in paralel, unul dintre ele mut. Comutatorul
   schimba doar care se aude, deci trecerea e instantanee si amandoua
   raman exact pe aceeasi secunda.

   Varianta veche oprea un fisier si sarea pe celalalt la aceeasi pozitie.
   Cu preload="none", fisierul neascultat inca nu avea metadata, deci
   `duration` era NaN, `currentTime` nu se putea seta si pornea de la zero.
   Daca browserul refuza doua redari simultane, cadem inapoi pe varianta
   cu sarit, dar de data asta asteptam metadata inainte. */
(function(){
  var raw = document.getElementById('abRaw'), mix = document.getElementById('abMix');
  if (!raw || !mix) return;

  /* daca nu s-a pus un URL in tema, foloseste audio-ul incorporat */
  function wire() {
    var A = window.MIXLAWS_AUDIO;
    if (!raw.getAttribute('src') && A && A.raw) raw.src = A.raw;
    if (!mix.getAttribute('src') && A && A.mix) mix.src = A.mix;
  }
  wire();
  window.addEventListener('load', wire);

  var btn = document.getElementById('abPlay'), prog = document.getElementById('abProg');
  var box = document.getElementById('ab');
  var cur = raw, playing = false, parallel = true, frame = 0;

  var PLAY = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>';
  var PAUSE = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M7 5h3.4v14H7zM13.6 5H17v14h-3.4z"/></svg>';

  function other(a){ return a === raw ? mix : raw; }

  /* pe iOS `volume` e doar de citit; `muted` se poate seta peste tot */
  function gain(){ raw.muted = (cur !== raw); mix.muted = (cur !== mix); }

  /* nu setam currentTime inainte sa stim durata, altfel e ignorat */
  function seek(a, pos){
    function go(){
      var d = a.duration, p = pos;
      if (typeof d === 'number' && isFinite(d) && d > 0) p = Math.min(pos, Math.max(0, d - 0.05));
      try { a.currentTime = p; } catch(e){}
    }
    if (a.readyState >= 1) go();
    else a.addEventListener('loadedmetadata', go, { once: true });
  }

  /* doua elemente audio pot aluneca unul fata de altul; le readucem pe linie */
  function resync(){
    var o = other(cur), t = cur.currentTime;
    if (!isFinite(t)) return;
    if (Math.abs(o.currentTime - t) > 0.12) seek(o, t);
  }

  function tick(){
    var d = cur.duration;
    if (isFinite(d) && d > 0) prog.style.width = (cur.currentTime / d * 100) + '%';
    if (playing && parallel && (++frame % 24 === 0)) resync();
    if (playing) requestAnimationFrame(tick);
  }

  function stop(){
    raw.pause(); mix.pause();
    playing = false; btn.innerHTML = PLAY;
  }

  btn.addEventListener('click', function(){
    if (playing){ stop(); return; }
    gain();
    playing = true; btn.innerHTML = PAUSE;
    var p1 = cur.play();
    if (p1 && p1.catch) p1.catch(function(){
      box && box.classList.add('err'); playing = false; btn.innerHTML = PLAY;
    });
    var p2 = other(cur).play();
    if (p2 && p2.catch) p2.catch(function(){ parallel = false; other(cur).pause(); });
    frame = 0;
    requestAnimationFrame(tick);
  });

  [raw, mix].forEach(function(a){
    a.addEventListener('ended', function(){
      if (a !== cur) return;               /* cel mut se termina primul uneori */
      stop();
      prog.style.width = '0%';
      try { raw.currentTime = 0; mix.currentTime = 0; } catch(e){}
    });
  });

  /* schimba lantul fara sa piarda pozitia */
  var tabs = document.querySelectorAll('.ab-b');
  for (var i = 0; i < tabs.length; i++){
    (function(t){
      t.addEventListener('click', function(){
        var next = t.dataset.t === 'raw' ? raw : mix;
        for (var j = 0; j < tabs.length; j++) tabs[j].classList.remove('on');
        t.classList.add('on');
        if (next === cur) return;

        var pos = cur.currentTime;
        var wasParallel = parallel && playing && !next.paused;
        cur = next;

        if (wasParallel){
          gain();                          /* doar schimbam ce se aude */
          resync();
        } else {
          other(cur).pause();
          seek(cur, pos);
          gain();
          if (playing){
            var pr = cur.play();
            if (pr && pr.catch) pr.catch(function(){ box && box.classList.add('err'); });
            requestAnimationFrame(tick);
          }
        }
      });
    })(tabs[i]);
  }
})();


/* ============ countdown pentru reducere ============ */
(function () {
  var el = document.getElementById('cdown');
  if (!el) return;
  var out = document.getElementById('cdownT');
  var raw = (el.dataset.end || '').trim();
  if (!raw) return;

  /* "2026-09-27 23:59" -> data locala, fara surprize de fus orar */
  var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
  if (!m) return;
  var end = new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59), 59);

  function two(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var left = end - new Date();
    if (left <= 0) { el.hidden = true; return; }
    el.hidden = false;
    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var mi = Math.floor(s / 60);   s -= mi * 60;
    out.textContent = (d > 0 ? d + 'd ' : '') + two(h) + ':' + two(mi) + ':' + two(s);
    setTimeout(tick, 1000);
  }
  tick();
})();


/* ============ audio: daca fisierul nu se incarca, spune-o ============ */
(function () {
  var box = document.getElementById('ab');
  if (!box) return;
  var note = document.createElement('p');
  note.className = 'ab-err';
  note.textContent = 'Preview unavailable right now.';
  box.appendChild(note);
  ['abRaw', 'abMix'].forEach(function (id) {
    var a = document.getElementById(id);
    if (a) a.addEventListener('error', function () {
      if (a.getAttribute('src')) box.classList.add('err');
    });
  });
})();


/* ============ clipurile ruleaza doar cat sunt pe ecran ============ */
(function () {
  var vids = document.querySelectorAll('.clipc video');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.play().catch(function () {}); }
      else { e.target.pause(); }
    });
  }, { threshold: 0.35 });
  for (var i = 0; i < vids.length; i++) io.observe(vids[i]);
})();


/* ============ carusel recenzii: glisare stanga-dreapta cu rAF ============ */
(function () {
  var boxes = document.querySelectorAll('.prevs');
  for (var b = 0; b < boxes.length; b++) init(boxes[b]);

  function init(box) {
    var view = box.querySelector('.pview'), track = box.querySelector('.ptrack');
    var slides = box.querySelectorAll('.pslide'), dots = box.querySelectorAll('.dots i');
    if (!view || !track || !slides.length) return;
    var k = 0, w = 0, x = 0, timer = null, raf = null;

    function measure() {
      w = view.clientWidth;
      var h = 0;
      for (var i = 0; i < slides.length; i++) h = Math.max(h, slides[i].offsetHeight);
      view.style.height = h + 'px';
      x = -k * w;
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    }
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function slideTo(n) {
      if (slides.length < 2) return;
      n = (n + slides.length) % slides.length;
      var from = x, to = -n * w, t0 = null, D = 420;
      k = n;
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('on', j === k);
      if (raf) cancelAnimationFrame(raf);
      function step(now) {
        if (t0 === null) t0 = now;
        var p = Math.min(1, (now - t0) / D);
        x = from + (to - from) * ease(p);
        track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
        if (p < 1) raf = requestAnimationFrame(step);
      }
      raf = requestAnimationFrame(step);
    }
    function auto() {
      clearInterval(timer);
      if (slides.length < 2) return;
      timer = setInterval(function () { slideTo(k + 1); }, 7000);
    }

    for (var d = 0; d < dots.length; d++) dots[d].addEventListener('click', function (e) {
      slideTo(+e.target.dataset.i); auto();
    });
    window.addEventListener('resize', measure);
    (window.__pmeasure = window.__pmeasure || []).push(measure);
    measure(); auto();
  }
})();


/* ============ tema deschisa / inchisa ============ */
(function () {
  var root = document.documentElement;
  /* tema inchisa oprita din setari: nu mai ascultam nimic aici */
  if (root.getAttribute('data-themelock') === '1') return;
  function apply(t) {
    if (t === 'light') root.setAttribute('data-theme', 'light');
    else root.removeAttribute('data-theme');
    var tog = document.querySelectorAll('[data-themetog]');
    for (var i = 0; i < tog.length; i++) {
      var icons = tog[i].querySelectorAll('i');
      if (icons[0]) icons[0].classList.toggle('on', t === 'light');
      if (icons[1]) icons[1].classList.toggle('on', t !== 'light');
    }
  }
  var saved = null;
  try { saved = localStorage.getItem('mxl-theme'); } catch (e) {}
  /* implicita vine din setarile temei; scriptul din <head> a pus-o deja,
     aici doar potrivim iconitele butonului */
  apply(saved || root.getAttribute('data-deftheme') || 'light');
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-themetog]') : null;
    if (!t) return;
    var next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
    apply(next);
    try { localStorage.setItem('mxl-theme', next); } catch (err) {}
  });
})();


/* ============ selector de DAW: butonul se deblocheaza dupa alegere ============ */
(function () {
  var box = document.querySelector('[data-dawpick]');
  if (!box) return;
  var buy = document.querySelector('[data-buy]');
  var field = document.querySelector('[data-daw-field]');
  var ready = document.querySelector('[data-buy-ready]');
  box.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.dp') : null;
    if (!b || b.disabled || b.dataset.ok !== '1') return;
    var all = box.querySelectorAll('.dp');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('sel');
    b.classList.add('sel');
    if (field) field.value = b.querySelector('span') ? b.querySelector('span').textContent.trim() : b.dataset.daw;
    if (buy && !buy.hasAttribute('data-soldout')) {
      buy.disabled = false;
      if (ready) buy.textContent = ready.textContent;
    }
  });
})();


/* ============ player before / after ============ */
(function () {
  var box = document.querySelector('[data-abx]');
  if (!box) return;
  var ex = 0, side = 'before', raf = null;
  var play = box.querySelector('[data-abx-play]');
  var prog = box.querySelector('.abx-prog');
  var auds = box.querySelectorAll('audio');

  function current() {
    for (var i = 0; i < auds.length; i++)
      if (auds[i].dataset.ex == ex && auds[i].dataset.side === side) return auds[i];
    return null;
  }
  function stopAll(keep) {
    for (var i = 0; i < auds.length; i++)
      if (auds[i] !== keep) { auds[i].pause(); }
  }
  function tick() {
    var a = current();
    if (a && a.duration) prog.style.width = (a.currentTime / a.duration * 100) + '%';
    raf = requestAnimationFrame(tick);
  }
  function icon(playing) {
    play.innerHTML = playing
      ? '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><rect x="7" y="5" width="3.6" height="14"/><rect x="13.4" y="5" width="3.6" height="14"/></svg>'
      : '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>';
  }

  play.addEventListener('click', function () {
    var a = current(); if (!a) return;
    if (a.paused) { stopAll(a); a.play().catch(function () {}); icon(true); if (!raf) tick(); }
    else { a.pause(); icon(false); }
  });

  box.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('.abx-tab') : null;
    if (tab) {
      var t = box.querySelectorAll('.abx-tab');
      for (var i = 0; i < t.length; i++) t[i].classList.remove('on');
      tab.classList.add('on');
      var was = current(); var playing = was && !was.paused; var at = was ? was.currentTime : 0;
      ex = +tab.dataset.ex; stopAll(null);
      var a = current(); if (a) { a.currentTime = at; if (playing) a.play().catch(function () {}); }
      return;
    }
    var sw = e.target.closest ? e.target.closest('.abx-b') : null;
    if (sw) {
      var s = box.querySelectorAll('.abx-b');
      for (var j = 0; j < s.length; j++) s[j].classList.remove('on');
      sw.classList.add('on');
      var prev = current(); var p2 = prev && !prev.paused; var t2 = prev ? prev.currentTime : 0;
      side = sw.dataset.side; stopAll(null);
      var b = current(); if (b) { b.currentTime = t2; if (p2) b.play().catch(function () {}); }
    }
  });

  for (var i = 0; i < auds.length; i++) auds[i].addEventListener('ended', function () { icon(false); });
})();

/* ---- benzi orizontale: sageti, tragere cu mouse-ul, bara de progres ---- */
(function(){
  var lanes = document.querySelectorAll('[data-lane]');
  if (!lanes.length) return;
  Array.prototype.forEach.call(lanes, function(lane){
    var row  = lane.querySelector('[data-lane-row]');
    var prev = lane.querySelector('[data-lane-prev]');
    var next = lane.querySelector('[data-lane-next]');
    var bar  = lane.querySelector('[data-lane-bar]');
    if (!row) return;

    function step(){
      var card = row.querySelector('.pcard');
      var w = card ? card.getBoundingClientRect().width : 240;
      return Math.round(w + 16);
    }
    function sync(){
      var max = row.scrollWidth - row.clientWidth;
      if (bar){
        var frac = row.clientWidth / Math.max(1, row.scrollWidth);
        bar.style.width = Math.max(12, Math.min(100, frac * 100)) + '%';
        var p = max > 0 ? row.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (p * (100 / Math.max(0.0001, frac) - 100)) + '%)';
      }
      if (prev) prev.disabled = row.scrollLeft <= 2;
      if (next) next.disabled = row.scrollLeft >= max - 2;
    }
    if (prev) prev.addEventListener('click', function(){ row.scrollLeft -= step(); });
    if (next) next.addEventListener('click', function(){ row.scrollLeft += step(); });
    row.addEventListener('scroll', sync, {passive:true});
    window.addEventListener('resize', sync);
    sync();

    /* tragere cu mouse-ul, ca la ei */
    var down = false, sx = 0, sl = 0, moved = 0;
    row.addEventListener('pointerdown', function(e){
      if (e.pointerType === 'touch') return;
      down = true; moved = 0; sx = e.clientX; sl = row.scrollLeft;
      row.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', function(e){
      if (!down) return;
      var d = e.clientX - sx;
      moved = Math.max(moved, Math.abs(d));
      row.scrollLeft = sl - d;
    });
    window.addEventListener('pointerup', function(){
      if (!down) return;
      down = false; row.style.cursor = '';
    });
    row.addEventListener('click', function(e){
      if (moved > 6){ e.preventDefault(); e.stopPropagation(); }
    }, true);
  });
})();

/* ---- carusel in hero ---- */
(function(){
  var wrap = document.querySelector('[data-hslides]');
  if (!wrap) return;
  var slides = wrap.querySelectorAll('[data-hslide]');
  var boxes = document.querySelectorAll('[data-hbox]');
  var sells = document.querySelectorAll('[data-hsell]');
  if (slides.length < 2) return;
  var dots = document.querySelectorAll('[data-hdot]');
  var prev = document.querySelector('[data-hprev]');
  var next = document.querySelector('[data-hnext]');
  var i = 0, timer = null;

  function show(n){
    i = (n + slides.length) % slides.length;
    for (var k = 0; k < slides.length; k++) slides[k].classList.toggle('on', k === i);
    for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('on', d === i);
    for (var b = 0; b < boxes.length; b++) boxes[b].classList.toggle('on', b === i);
    for (var c = 0; c < sells.length; c++) sells[c].classList.toggle('on', c === i);
  }
  function go(n){ show(n); restart(); }

  /* Schimbarea singura e oprita implicit: omul citeste un produs, nu vrea
     sa-i fuga de sub ochi. Se aprinde din setarile sectiunii, iar atunci
     intervalul vine tot de acolo. */
  var AUTO = parseInt(wrap.dataset.auto || '0', 10) || 0;
  function restart(){
    if (timer) clearInterval(timer);
    if (AUTO <= 0) return;
    timer = setInterval(function(){ show(i + 1); }, AUTO * 1000);
  }
  if (prev) prev.addEventListener('click', function(){ go(i - 1); });
  if (next) next.addEventListener('click', function(){ go(i + 1); });

  /* pastilele de sub hero: alegi produsul, hero-ul sare pe el */
  var picks = document.querySelectorAll('[data-hpick]');
  for (var q = 0; q < picks.length; q++){
    (function(btn){
      btn.addEventListener('click', function(){ go(parseInt(btn.dataset.hpick, 10) || 0); });
    })(picks[q]);
  }
  var oldShow = show;
  show = function(n){
    oldShow(n);
    for (var q2 = 0; q2 < picks.length; q2++){
      picks[q2].classList.toggle('on', parseInt(picks[q2].dataset.hpick, 10) === i);
    }
  };
  for (var d = 0; d < dots.length; d++){
    (function(k){ dots[k].addEventListener('click', function(){ go(k); }); })(d);
  }

  /* ?preset=handle in adresa: venim din meniu sau din grila de colectie,
     deci hero-ul porneste direct pe produsul cerut, nu pe primul. */
  try {
    var want = new URLSearchParams(window.location.search).get('preset');
    if (want) {
      for (var w = 0; w < slides.length; w++) {
        if (slides[w].dataset.handle === want) { show(w); break; }
      }
    }
  } catch (e) {}

  restart();
})();

/* ---- banda cu DAW-uri: miscata din JS, ca sa mearga si cu animatiile
       oprite din sistem (asa era si vechea bara rosie) ---- */
(function(){
  var run = document.querySelector('.dawbar .db-run');
  if (!run) return;
  var half = 0, x = 0, last = 0;
  var SPEED = 42; /* px pe secunda, de la stanga la dreapta */

  function measure(){
    var first = run.firstElementChild;
    half = first ? first.getBoundingClientRect().width : run.scrollWidth / 2;
    if (!half) half = run.scrollWidth / 2;
    x = -half;
  }
  measure();
  window.addEventListener('resize', measure);

  function frame(now){
    if (!last) last = now;
    var dt = (now - last) / 1000;
    last = now;
    if (dt > 0.25) dt = 0.016;
    x += SPEED * dt;
    if (x >= 0) x -= half;
    run.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();

/* ---------- cutia 3D: rotire cu mouse-ul sau cu degetul ---------- */
(function(){
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(wrap){
    var box = wrap.querySelector('[data-b3box]');
    if (!box) return;
    var REST = {ry:-32, rx:8};
    var cur  = {ry:REST.ry, rx:REST.rx};
    var aim  = {ry:REST.ry, rx:REST.rx};
    var drag = null, idle = 0, live = false;

    function paint(){
      box.style.transform = 'rotateX(' + cur.rx.toFixed(2) + 'deg) rotateY(' + cur.ry.toFixed(2) + 'deg)';
    }
    function tick(){
      if (!drag && idle > 0){
        idle--;
        if (idle === 0){ aim.ry = REST.ry; aim.rx = REST.rx; }
      }
      if (!drag && idle === 0 && !still){
        var t = performance.now() / 2600;
        aim.ry = REST.ry + Math.sin(t) * 3.2;
        aim.rx = REST.rx + Math.cos(t * 0.8) * 1.4;
      }
      cur.ry += (aim.ry - cur.ry) * 0.10;
      cur.rx += (aim.rx - cur.rx) * 0.10;
      paint();
      if (live) requestAnimationFrame(tick);
    }

    wrap.addEventListener('pointerdown', function(e){
      drag = {x:e.clientX, y:e.clientY, ry:aim.ry, rx:aim.rx};
      wrap.classList.add('touched');
      try { wrap.setPointerCapture(e.pointerId); } catch(err){}
    });
    wrap.addEventListener('pointermove', function(e){
      if (!drag) return;
      aim.ry = drag.ry + (e.clientX - drag.x) * 0.42;
      aim.rx = Math.max(-26, Math.min(26, drag.rx - (e.clientY - drag.y) * 0.30));
    });
    function stop(){ if (drag){ drag = null; idle = 110; } }
    wrap.addEventListener('pointerup', stop);
    wrap.addEventListener('pointercancel', stop);
    wrap.addEventListener('pointerleave', stop);

    /* nu invartim degeaba cand cutia nu e pe ecran */
    if (window.IntersectionObserver){
      new IntersectionObserver(function(rows){
        rows.forEach(function(r){
          if (r.isIntersecting && !live){ live = true; requestAnimationFrame(tick); }
          else if (!r.isIntersecting){ live = false; }
        });
      }, {rootMargin:'120px'}).observe(wrap);
    } else {
      live = true; requestAnimationFrame(tick);
    }
    paint();
  }

  function boot(){
    document.querySelectorAll('[data-box3d]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ---------- tabelul cu exemple audio ----------
   Un rand = doua fisiere care merg in paralel, unul mut. Comutatorul
   schimba doar care se aude, deci nu repornim si nu pierdem secunda.
   Cand pornesti un rand, restul se opresc. */
(function(){
  var wrap = document.querySelector('[data-abt]');
  if (!wrap) return;

  var PLAY  = '<svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>';
  var PAUSE = '<svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M7 5h3.4v14H7zM13.6 5H17v14h-3.4z"/></svg>';

  function mmss(s){
    if (!isFinite(s) || s < 0) return '0:00';
    var m = Math.floor(s / 60), r = Math.floor(s % 60);
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  var rows = [];

  function stopAll(except){
    rows.forEach(function(r){ if (r !== except) r.stop(); });
  }

  wrap.querySelectorAll('[data-abt-row]').forEach(function(el){
    var before = el.querySelector('audio[data-side="before"]');
    var after  = el.querySelector('audio[data-side="after"]');
    if (!before || !after) return;

    var btn  = el.querySelector('[data-abt-play]');
    var wave = el.querySelector('[data-abt-wave]');
    var prog = el.querySelector('[data-abt-prog]');
    var time = el.querySelector('[data-abt-time]');
    var tabs = el.querySelectorAll('.abt-b');

    var cur = before, playing = false, parallel = true, frame = 0;
    function other(){ return cur === before ? after : before; }
    function gain(){ before.muted = (cur !== before); after.muted = (cur !== after); }

    function seek(a, pos){
      function go(){
        var d = a.duration, p = pos;
        if (typeof d === 'number' && isFinite(d) && d > 0) p = Math.min(pos, Math.max(0, d - 0.05));
        try { a.currentTime = p; } catch(e){}
      }
      if (a.readyState >= 1) go();
      else a.addEventListener('loadedmetadata', go, { once: true });
    }
    function resync(){
      var o = other(), t = cur.currentTime;
      if (!isFinite(t)) return;
      if (Math.abs(o.currentTime - t) > 0.12) seek(o, t);
    }

    function showTime(){
      var d = cur.duration;
      if (isFinite(d) && d > 0) time.textContent = mmss(playing ? d - cur.currentTime : d);
    }
    before.addEventListener('loadedmetadata', showTime);
    after.addEventListener('loadedmetadata', showTime);

    function tick(){
      var d = cur.duration;
      if (isFinite(d) && d > 0){
        prog.style.width = (cur.currentTime / d * 100) + '%';
        showTime();
      }
      if (playing && parallel && (++frame % 24 === 0)) resync();
      if (playing) requestAnimationFrame(tick);
    }

    var api = {
      stop: function(){
        before.pause(); after.pause();
        playing = false; btn.innerHTML = PLAY;
        el.classList.remove('is-playing');
        showTime();
      },
      start: function(){
        stopAll(api);
        gain();
        playing = true; btn.innerHTML = PAUSE;
        el.classList.add('is-playing');
        var p1 = cur.play();
        if (p1 && p1.catch) p1.catch(function(){ api.stop(); });
        var p2 = other().play();
        if (p2 && p2.catch) p2.catch(function(){ parallel = false; other().pause(); });
        frame = 0;
        requestAnimationFrame(tick);
      }
    };
    rows.push(api);

    btn.addEventListener('click', function(){ playing ? api.stop() : api.start(); });

    /* click pe unda: sari acolo */
    wave.addEventListener('click', function(e){
      var r = wave.getBoundingClientRect();
      var f = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      var d = cur.duration;
      if (!isFinite(d) || d <= 0) return;
      seek(cur, d * f); seek(other(), d * f);
      prog.style.width = (f * 100) + '%';
    });

    [before, after].forEach(function(a){
      a.addEventListener('ended', function(){
        if (a !== cur) return;
        api.stop();
        prog.style.width = '0%';
        try { before.currentTime = 0; after.currentTime = 0; } catch(e){}
      });
    });

    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        var next = t.dataset.side === 'before' ? before : after;
        tabs.forEach(function(x){ x.classList.remove('on'); });
        t.classList.add('on');
        if (next === cur) return;

        var pos = cur.currentTime;
        var keep = parallel && playing && !next.paused;
        cur = next;

        if (keep){ gain(); resync(); }
        else {
          other().pause();
          seek(cur, pos);
          gain();
          if (playing){
            var pr = cur.play();
            if (pr && pr.catch) pr.catch(function(){ api.stop(); });
            requestAnimationFrame(tick);
          }
        }
      });
    });

    showTime();
  });
})();


/* ---- playerul din hero ----
   Canta demo-ul produsului aflat pe ecran, nu unul singur pentru tot
   hero-ul. Fiecare slide poarta pe el linkurile lui (data-raw / data-mix);
   cand se schimba slide-ul, schimbam sursele si pornim de la zero - e alt
   cantec, are alta durata.

   Doua fisiere merg in paralel, unul mut, deci comutatorul Raw / preset
   schimba doar ce se aude, nu reia redarea. */
(function(){
  var raw = document.getElementById('heroRaw'), mix = document.getElementById('heroMix');
  if (!raw || !mix) return;
  if (!document.querySelector('[data-hab-row]')) return;

  var PLAY  = '<svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>';
  var PAUSE = '<svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor"><path d="M7 5h3.4v14H7zM13.6 5H17v14h-3.4z"/></svg>';
  var cur = raw, playing = false, parallel = true, row = null;

  function other(){ return cur === raw ? mix : raw; }
  function gain(){ raw.muted = (cur !== raw); mix.muted = (cur !== mix); }

  /* randul de pe slide-ul vizibil */
  function liveRow(){
    var on = document.querySelector('.hslide.on [data-hab-row]');
    return on || document.querySelector('[data-hab-row]');
  }
  function icons(){
    document.querySelectorAll('[data-hab-play]').forEach(function(b){
      b.innerHTML = playing ? PAUSE : PLAY;
    });
  }
  function stop(){ raw.pause(); mix.pause(); playing = false; icons(); }
  function fmt(s){
    if (!isFinite(s) || s < 0) s = 0;
    var m = Math.floor(s / 60), r = Math.floor(s % 60);
    return m + ':' + (r < 10 ? '0' : '') + r;
  }
  function paint(){
    var d = cur.duration, t = cur.currentTime || 0, f = 0;
    if (isFinite(d) && d > 0) f = Math.max(0, Math.min(1, t / d));
    var w = (f * 100) + '%';
    document.querySelectorAll('[data-hab-prog]').forEach(function(p){ p.style.width = w; });
    document.querySelectorAll('[data-hab-time]').forEach(function(el){ el.textContent = fmt(t); });
  }
  function reset(){
    document.querySelectorAll('[data-hab-prog]').forEach(function(p){ p.style.width = '0%'; });
    document.querySelectorAll('[data-hab-time]').forEach(function(el){ el.textContent = '0:00'; });
  }
  function tick(){ if (!playing) return; paint(); requestAnimationFrame(tick); }

  /* incarca sursele slide-ului vizibil; true daca s-a schimbat ceva */
  function sync(){
    var r = liveRow();
    if (!r || r === row) return false;
    row = r;
    stop(); reset();
    raw.src = r.dataset.raw || '';
    mix.src = r.dataset.mix || '';
    cur = raw; parallel = true;
    document.querySelectorAll('[data-hab-side]').forEach(function(x){
      x.classList.toggle('on', x.dataset.habSide === 'raw');
    });
    gain();
    return true;
  }
  sync();

  /* slide-ul se schimba din sageti, pastile sau singur: verificam periodic
     care e vizibil. Un observer pe clasa .on e mai ieftin decat un timer. */
  var slides = document.querySelectorAll('[data-hslide]');
  if (window.MutationObserver && slides.length) {
    var mo = new MutationObserver(function(){ sync(); });
    slides.forEach(function(sl){ mo.observe(sl, { attributes: true, attributeFilter: ['class'] }); });
  }

  document.addEventListener('click', function(e){
    if (!e.target.closest) return;

    var w = e.target.closest('[data-hab-wave]');
    if (w){
      sync();
      var d = cur.duration;
      if (isFinite(d) && d > 0){
        var box = w.getBoundingClientRect();
        var f = Math.max(0, Math.min(1, (e.clientX - box.left) / box.width));
        try { raw.currentTime = d * f; mix.currentTime = d * f; } catch(err){}
        paint();
      }
      return;
    }

    var p = e.target.closest('[data-hab-play]');
    if (p){
      sync();
      if (playing){ stop(); return; }
      if (!mix.getAttribute('src')) return;
      gain();
      playing = true; icons();
      var a = cur.play();
      if (a && a.catch) a.catch(function(){ stop(); });
      var b = other().play();
      if (b && b.catch) b.catch(function(){ parallel = false; other().pause(); });
      requestAnimationFrame(tick);
      return;
    }

    var t = e.target.closest('[data-hab-side]');
    if (!t) return;
    var slide = t.closest('.hslide') || document;
    slide.querySelectorAll('[data-hab-side]').forEach(function(x){ x.classList.remove('on'); });
    t.classList.add('on');
    var next = t.dataset.habSide === 'raw' ? raw : mix;
    if (next === cur) return;
    var pos = cur.currentTime;
    var keep = parallel && playing && !next.paused;
    cur = next;
    if (keep){ gain(); }
    else {
      other().pause();
      try { cur.currentTime = pos; } catch(err){}
      gain();
      if (playing){ var pr = cur.play(); if (pr && pr.catch) pr.catch(function(){ stop(); }); }
    }
    paint();
  });

  [raw, mix].forEach(function(a){
    a.addEventListener('ended', function(){
      if (a !== cur) return;
      stop();
      try { raw.currentTime = 0; mix.currentTime = 0; } catch(e){}
      reset();
    });
    a.addEventListener('timeupdate', function(){ if (a === cur && !playing) paint(); });
    a.addEventListener('loadedmetadata', function(){ if (a === cur) paint(); });
  });
})();


/* ---- valul din banda de sus ----
   Taiem textul in litere si dam fiecareia un indice. Animatia e aceeasi
   pentru toate, doar decalajul difera, asa ca unda pare ca se plimba prin
   cuvant. Taiem din JS ca sa nu umplem HTML-ul cu span-uri.
   Spatiile raman spatii: le punem in span-uri cu white-space:pre. */
(function () {
  var tk = document.querySelector('.tk');
  if (!tk) return;
  var runs = tk.querySelectorAll('.tk-run');

  /* Un sir prea scurt lasa o gaura: dupa ce prima copie iese din ecran,
     a doua nu apuca sa acopere latimea. Multiplicam continutul pana cand
     o copie e mai lata decat fereastra, apoi cele doua copii se leaga. */
  if (runs.length === 2) {
    var seed = runs[0].innerHTML;
    var need = Math.ceil((window.innerWidth + 200) / Math.max(1, runs[0].scrollWidth));
    if (need > 1 && need < 40) {
      var html = '';
      for (var k = 0; k < need; k++) html += seed;
      runs[0].innerHTML = html;
      runs[1].innerHTML = html;
    }
  }

  var items = tk.querySelectorAll('.tk-i');
  if (!items.length) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  items.forEach(function (el) {
    var txt = el.textContent;
    if (!txt || el.querySelector('span')) return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < txt.length; i++) {
      var s = document.createElement('span');
      s.textContent = txt[i];
      s.style.setProperty('--i', i);
      frag.appendChild(s);
    }
    el.textContent = '';
    el.appendChild(frag);
  });
})();


/* ============ fereastra "Hear every before & after" ============
   Un singur player pentru toata fereastra. Doua fisiere merg in paralel,
   unul mut, deci comutatorul Raw / Preset schimba doar ce se aude, nu
   reia de la zero. Cand alegi alt exemplu din grila, schimbam sursele si
   pornim de la inceput - e alt cantec, are alta durata. */
(function () {
  var root = document.getElementById('mxlHear');
  if (!root) return;

  var raw = document.getElementById('haRaw'), mix = document.getElementById('haMix');
  var picks = [].slice.call(root.querySelectorAll('[data-ha-pick]'));
  if (!raw || !mix || !picks.length) return;

  var img   = root.querySelector('[data-ha-img]');
  var noart = root.querySelector('[data-ha-noart]');
  var nameEl= root.querySelector('[data-ha-name]');
  var subEl = root.querySelector('[data-ha-sub]');
  var prog  = root.querySelector('[data-ha-prog]');
  var wave  = root.querySelector('[data-ha-wave]');
  var timeEl= root.querySelector('[data-ha-time]');
  var playB = root.querySelector('[data-ha-play]');
  var tog   = root.querySelector('[data-ha-tog]');
  var lRaw  = root.querySelector('[data-ha-lraw]');
  var lMix  = root.querySelector('[data-ha-lmix]');

  var PLAY  = '<svg viewBox="0 0 24 24" width="19" height="19" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>';
  var PAUSE = '<svg viewBox="0 0 24 24" width="19" height="19" fill="currentColor"><path d="M7 5h3.4v14H7zM13.6 5H17v14h-3.4z"/></svg>';

  var cur = raw, playing = false, parallel = true, at = -1, lastFocus = null;

  function other(){ return cur === raw ? mix : raw; }
  function gain(){ raw.muted = (cur !== raw); mix.muted = (cur !== mix); }
  function icons(){ playB.innerHTML = playing ? PAUSE : PLAY; }
  function fmt(s){
    if (!isFinite(s) || s < 0) s = 0;
    var m = Math.floor(s / 60), r = Math.floor(s % 60);
    return m + ':' + (r < 10 ? '0' : '') + r;
  }
  function paint(){
    var d = cur.duration, t = cur.currentTime || 0, f = 0;
    if (isFinite(d) && d > 0) f = Math.max(0, Math.min(1, t / d));
    prog.style.width = (f * 100) + '%';
    timeEl.textContent = fmt(t);
  }
  function tick(){ if (!playing) return; paint(); requestAnimationFrame(tick); }
  function stop(){ raw.pause(); mix.pause(); playing = false; icons(); }
  function reset(){ prog.style.width = '0%'; timeEl.textContent = '0:00'; }

  function side(toMix){
    var next = toMix ? mix : raw;
    tog.setAttribute('aria-checked', toMix ? 'true' : 'false');
    lRaw.classList.toggle('on', !toMix);
    lMix.classList.toggle('on', toMix);
    if (next === cur) return;
    var pos = cur.currentTime;
    var keep = parallel && playing && !next.paused;
    cur = next;
    if (keep) { gain(); }
    else {
      other().pause();
      try { cur.currentTime = pos; } catch (e) {}
      gain();
      if (playing) { var pr = cur.play(); if (pr && pr.catch) pr.catch(function(){ stop(); }); }
    }
    paint();
  }

  function load(i, autoplay) {
    if (i === at) return;
    var b = picks[i];
    if (!b) return;
    at = i;
    picks.forEach(function (x, k) { x.classList.toggle('on', k === i); });

    stop(); reset();
    raw.src = b.dataset.raw || '';
    mix.src = b.dataset.mix || '';
    cur = raw; parallel = true;
    side(false);
    gain();

    nameEl.textContent = b.dataset.name || '';
    subEl.textContent  = b.dataset.sub || '';
    subEl.parentNode.hidden = !b.dataset.sub;
    lMix.textContent   = b.dataset.name || 'Preset';

    if (b.dataset.img) { img.src = b.dataset.img; img.alt = b.dataset.name || ''; img.hidden = false; noart.hidden = true; }
    else { img.hidden = true; img.removeAttribute('src'); noart.hidden = false; }

    if (autoplay) play();
  }

  function play() {
    if (playing) { stop(); return; }
    gain();
    playing = true; icons();
    var a = cur.play();
    if (a && a.catch) a.catch(function(){ stop(); });
    var b = other().play();
    if (b && b.catch) b.catch(function(){ parallel = false; other().pause(); });
    requestAnimationFrame(tick);
  }

  function open() {
    lastFocus = document.activeElement;
    if (at < 0) load(0, false);
    root.classList.add('open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { playB.focus(); }, 60);
  }
  function close() {
    stop();
    root.classList.remove('open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-ha-open]'))  { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-ha-close]')) { close(); return; }
    if (!root.contains(e.target)) return;

    if (e.target.closest('[data-ha-play]')) { play(); return; }
    if (e.target.closest('[data-ha-tog]'))  { side(tog.getAttribute('aria-checked') !== 'true'); return; }

    var w = e.target.closest('[data-ha-wave]');
    if (w) {
      var d = cur.duration;
      if (isFinite(d) && d > 0) {
        var box = w.getBoundingClientRect();
        var f = Math.max(0, Math.min(1, (e.clientX - box.left) / box.width));
        try { raw.currentTime = d * f; mix.currentTime = d * f; } catch (err) {}
        paint();
      }
      return;
    }
    var p = e.target.closest('[data-ha-pick]');
    if (p) { load(picks.indexOf(p), true); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('open')) close();
  });

  [raw, mix].forEach(function (a) {
    a.addEventListener('ended', function () {
      if (a !== cur) return;
      stop();
      try { raw.currentTime = 0; mix.currentTime = 0; } catch (e) {}
      reset();
    });
    a.addEventListener('loadedmetadata', function () { if (a === cur) paint(); });
  });
})();


/* ============ fereastra cu toate produsele ============
   Deschisa de pastila "view all". Nu duce nicaieri: cardurile poarta
   acelasi data-hpick ca pastilele de sub hero, deci carusel-ul le prinde
   singur si sare pe produsul ales. Noi doar deschidem si inchidem. */
(function () {
  var root = document.getElementById('mxlAll');
  if (!root) return;
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    root.classList.add('open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var first = root.querySelector('.ap-it');
    setTimeout(function () { if (first) first.focus(); }, 60);
  }
  function close() {
    root.classList.remove('open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-all-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-all-close]')) { close(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('open')) close();
  });
})();


/* ============ un singur player o data ============
   Trei locuri canta pe site: hero-ul, tabelul de exemple si fereastra
   "hear every". Fiecare foloseste doua fisiere in paralel, unul mut, deci
   nu putem opri pur si simplu tot ce nu e elementul curent - i-am taia
   propriul partener. Grupam dupa containerul lor: ce e in afara grupului
   care tocmai a pornit, se opreste. */
(function () {
  function groupOf(a) {
    return a.closest('[data-abt-row]') ||
           a.closest('#mxlHear') ||
           (a.id === 'heroRaw' || a.id === 'heroMix' ? document.body : null);
  }
  document.addEventListener('play', function (e) {
    var a = e.target;
    if (!a || a.tagName !== 'AUDIO') return;
    var mine = groupOf(a);
    document.querySelectorAll('audio').forEach(function (o) {
      if (o === a || o.paused) return;
      if (groupOf(o) === mine) return;   /* partenerul lui, merge in paralel */
      o.pause();
    });
  }, true);
})();


/* ---- ticul de la click ----
   Sunetul e generat pe loc cu Web Audio, nu incarcam niciun fisier: un
   impuls scurt de sinus plus un strop de zgomot, 40 ms in total. Pornim
   contextul abia la primul click al vizitatorului, altfel browserele il
   blocheaza si rman cu un context suspendat degeaba.

   Nu ticaie peste playerele de voci: daca ceva canta, tacem, ca sa nu
   murdarim exact demo-ul pe care omul a venit sa-l asculte. */
(function () {
  var b = document.body;
  if (!b || b.dataset.uiclick !== '1') return;

  var AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return;

  var vol = (parseFloat(b.dataset.uiclickvol || '20') || 20) / 100;
  var ctx = null, noise = null, snapBuf = null;

  /* elementele care merita un tic: butoane si pastile, nu orice pixel */
  var HIT = 'button, .hpill, .cd-row, .hab-b, .abt-b, .cd-btn, .cd-tier,' +
            ' [data-hpick], [data-hab-side], [data-abt-side], [data-cart-open],' +
            ' .hbuy button, .hbuy2, .nav a, .mega a, .cd-x';

  function audible() {
    var on = false;
    document.querySelectorAll('audio').forEach(function (a) {
      if (!a.paused && !a.ended && !a.muted) on = true;
    });
    return on;
  }

  function buffer() {
    if (noise) return noise;
    var n = Math.floor(ctx.sampleRate * 0.02);
    noise = ctx.createBuffer(1, n, ctx.sampleRate);
    var d = noise.getChannelData(0);
    for (var i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / n, 6);
    return noise;
  }

  /* zgomot foarte scurt, taiat abrupt: asta e de fapt un click de mouse.
     Un buton mecanic nu are nota, are o pocnitura de banda larga. */
  function snap() {
    if (snapBuf) return snapBuf;
    var n = Math.floor(ctx.sampleRate * 0.012);
    snapBuf = ctx.createBuffer(1, n, ctx.sampleRate);
    var d = snapBuf.getChannelData(0);
    for (var i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / n, 2.2);
    return snapBuf;
  }

  /* Cinci variante, alese din Theme settings. Toate generate pe loc, deci
     nu incarcam niciun fisier.

       mouse - pocnitura scurta de buton mecanic, sub 40 ms (implicit)
       tock  - lemn, mat
       tick  - scurt si uscat
       soft  - rotund, aproape suflat
       pop   - bulina
  */
  var KIND = (b.dataset.uiclickkind || 'mouse').toLowerCase();
  var VOICES = {
    mouse:{ type:'sine',     f0:180, f1:90,  lp0:5200, lp1:2600, dur:0.028, noise:0,    nf:2900, osc:0.30, snap:true },
    tock: { type:'triangle', f0:420, f1:190, lp0:1400, lp1:420,  dur:0.09,  noise:0.22, nf:1700 },
    tick: { type:'square',   f0:900, f1:520, lp0:3200, lp1:1400, dur:0.045, noise:0.30, nf:3200 },
    soft: { type:'sine',     f0:300, f1:150, lp0:900,  lp1:300,  dur:0.14,  noise:0.06, nf:900  },
    pop:  { type:'sine',     f0:620, f1:150, lp0:2200, lp1:600,  dur:0.11,  noise:0.10, nf:1200 }
  };

  function tick(soft) {
    if (!ctx || ctx.state !== 'running') return;
    var v = VOICES[KIND] || VOICES.mouse;
    var t = ctx.currentTime;

    var lp = ctx.createBiquadFilter();
    lp.type = 'lowpass';
    lp.frequency.setValueAtTime(v.lp0, t);
    lp.frequency.exponentialRampToValueAtTime(v.lp1, t + v.dur * 0.8);
    lp.Q.value = 0.7;

    var g = ctx.createGain();
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(vol * (soft ? 0.6 : 1), t + 0.004);
    g.gain.exponentialRampToValueAtTime(0.0001, t + v.dur);
    lp.connect(g); g.connect(ctx.destination);

    var o = ctx.createOscillator();
    o.type = v.type;
    o.frequency.setValueAtTime(soft ? v.f0 * 0.8 : v.f0, t);
    o.frequency.exponentialRampToValueAtTime(soft ? v.f1 * 0.8 : v.f1, t + v.dur * 0.9);
    if (v.osc != null && v.osc < 1) {
      var og = ctx.createGain(); og.gain.value = v.osc;
      o.connect(og); og.connect(lp);
    } else {
      o.connect(lp);
    }
    o.start(t); o.stop(t + v.dur + 0.01);

    /* pocnitura, in afara filtrului trece-jos: prin el si-ar pierde exact
       varfurile care o fac sa sune a buton apasat, nu a beep */
    if (v.snap) {
      var sp = ctx.createBufferSource(); sp.buffer = snap();
      var hp = ctx.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 1100;
      var pk = ctx.createBiquadFilter(); pk.type = 'peaking';
      pk.frequency.value = 2900; pk.Q.value = 1.4; pk.gain.value = 5;
      var sg = ctx.createGain();
      sg.gain.setValueAtTime(vol * (soft ? 0.5 : 0.8), t);
      sg.gain.exponentialRampToValueAtTime(0.0001, t + 0.014);
      sp.connect(hp); hp.connect(pk); pk.connect(sg); sg.connect(ctx.destination);
      sp.start(t);
    }

    if (v.noise > 0) {
      var sN = ctx.createBufferSource(); sN.buffer = buffer();
      var bp = ctx.createBiquadFilter(); bp.type = 'bandpass';
      bp.frequency.value = v.nf; bp.Q.value = 1.1;
      var ng = ctx.createGain();
      ng.gain.setValueAtTime(vol * v.noise, t);
      ng.gain.exponentialRampToValueAtTime(0.0001, t + 0.03);
      sN.connect(bp); bp.connect(ng); ng.connect(ctx.destination);
      sN.start(t);
    }
  }

  document.addEventListener('pointerdown', function (e) {
    if (!ctx) {
      try { ctx = new AC(); } catch (err) { return; }
    }
    if (ctx.state === 'suspended' && ctx.resume) ctx.resume();
    var el = e.target.closest ? e.target.closest(HIT) : null;
    if (!el || el.disabled || el.classList.contains('off')) return;
    if (audible()) return;
    tick(el.tagName === 'A');
  }, { passive: true });
})();

/* ---------- VOCALSYRUP: parallax foarte discret pe poza din hero ---------- */
(function () {
  var art = document.querySelector('[data-vs-parallax]');
  if (!art) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var hero = art.closest('.vsx-hero');
  if (!hero) return;
  var max = 7; /* px - discret, nu gimmick */
  hero.addEventListener('mousemove', function (e) {
    var r = hero.getBoundingClientRect();
    var px = (e.clientX - r.left) / r.width - 0.5;
    var py = (e.clientY - r.top) / r.height - 0.5;
    art.style.transform = 'translate3d(' + (px * max * 2).toFixed(1) + 'px,' + (py * max).toFixed(1) + 'px,0)';
  }, { passive: true });
  hero.addEventListener('mouseleave', function () { art.style.transform = 'translate3d(0,0,0)'; }, { passive: true });
})();

/* ---------- VOCALSYRUP: puncte de click pe poza pluginului ---------- */
(function () {
  document.addEventListener('click', function (e) {
    var dot = e.target.closest ? e.target.closest('[data-vs-hot]') : null;
    if (!dot) return;
    var wrap = dot.closest('[data-vs-hotspots]');
    if (!wrap) return;
    var dots = wrap.querySelectorAll('[data-vs-hot]');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('on', dots[i] === dot);
    var panel = wrap.parentElement ? wrap.parentElement.querySelector('[data-vs-hotpanel]') : null;
    if (!panel) return;
    var lbl = panel.querySelector('[data-vs-hotlbl]');
    var desc = panel.querySelector('[data-vs-hotdesc]');
    if (lbl) lbl.textContent = dot.dataset.lbl || '';
    if (desc) desc.textContent = dot.dataset.desc || '';
  });
})();

/* ---------- VOCALSYRUP: modal simplu pentru video creatori ---------- */
(function () {
  var modal = document.querySelector('[data-vs-vidmodal]');
  if (!modal) return;
  var player = modal.querySelector('[data-vs-vidplayer]');

  function open(src) {
    if (!src) return;
    player.src = src;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var p = player.play();
    if (p && p.catch) p.catch(function () {});
  }
  function close() {
    player.pause();
    player.removeAttribute('src');
    player.load();
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest ? e.target.closest('[data-vs-vidopen]') : null;
    if (card) { open(card.dataset.src); return; }
    if (e.target.closest && e.target.closest('[data-vs-vidclose]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });
})();

/* ---------- VOCALSYRUP: bara sticky de cumparare ---------- */
(function () {
  var bar = document.querySelector('[data-vs-stickybuy]');
  if (!bar) return;
  var hero = document.querySelector('.vsx-hero');
  var buy = document.getElementById('vs-buy');
  if (!('IntersectionObserver' in window)) return;

  var heroVisible = true, buyVisible = false;

  function sync() {
    var show = !heroVisible && !buyVisible;
    bar.hidden = false;
    bar.classList.toggle('show', show);
  }

  if (hero) {
    new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting;
      sync();
    }, { threshold: 0 }).observe(hero);
  } else {
    heroVisible = false;
  }

  if (buy) {
    new IntersectionObserver(function (entries) {
      buyVisible = entries[0].isIntersecting;
      sync();
    }, { threshold: 0.15 }).observe(buy);
  }
})();

/* ---------- VOCALSYRUP: acordeon FAQ ---------- */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-vs-faqbtn]') : null;
    if (!btn) return;
    var item = btn.closest('.vsx-faqitem');
    var panel = item ? item.querySelector('[data-vs-faqpanel]') : null;
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';

    if (open) {
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () { panel.style.height = '0px'; });
      btn.setAttribute('aria-expanded', 'false');
      panel.addEventListener('transitionend', function h() {
        panel.hidden = true; panel.removeEventListener('transitionend', h);
      }, { once: true });
    } else {
      panel.hidden = false;
      panel.style.height = '0px';
      requestAnimationFrame(function () { panel.style.height = panel.scrollHeight + 'px'; });
      btn.setAttribute('aria-expanded', 'true');
      panel.addEventListener('transitionend', function h() {
        panel.style.height = 'auto'; panel.removeEventListener('transitionend', h);
      }, { once: true });
    }
  });
})();

/* ---------- VOCALSYRUP: selector de arome in laboratorul audio ----------
   Comutarea intre arome NU incearca sa pastreze pozitia (doar comutarea
   DRY/SYRUP pe aceeasi aroma face asta, mai sus) - doar opreste si
   ascunde randul vechi, arata randul nou, gata de la zero. */
(function(){
  var sel = document.querySelector('[data-vs-flavorsel]');
  if (!sel) return;
  var sec = sel.closest('.vsx-audiosec');
  var wrap = sec && sec.querySelector('[data-abt]');
  if (!wrap) return;

  var PLAY = '<svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>';
  var picks = sel.querySelectorAll('[data-vs-flavor]');
  var rows = wrap.querySelectorAll('[data-vs-flavor-row]');

  picks.forEach(function(p){
    p.addEventListener('click', function(){
      if (p.classList.contains('on')) return;
      picks.forEach(function(x){ x.classList.remove('on'); x.setAttribute('aria-selected', 'false'); });
      p.classList.add('on'); p.setAttribute('aria-selected', 'true');

      var idx = p.getAttribute('data-vs-flavor');
      rows.forEach(function(r){
        if (r.getAttribute('data-vs-flavor-row') === idx){
          r.classList.remove('is-hidden');
        } else if (!r.classList.contains('is-hidden')) {
          r.querySelectorAll('audio').forEach(function(a){ a.pause(); });
          var btn = r.querySelector('[data-abt-play]');
          var prog = r.querySelector('[data-abt-prog]');
          if (btn) btn.innerHTML = PLAY;
          if (prog) prog.style.width = '0%';
          r.classList.remove('is-playing');
          r.classList.add('is-hidden');
        }
      });
    });
  });
})();

/* ---------- VOCALSYRUP: drag pentru randul de module (mouse) ----------
   Rândul de 11 module foloseşte deja overflow-x:auto + scroll-snap, ceea
   ce ajunge perfect pe touch (swipe nativ). Pe desktop adăugăm doar
   click-and-drag cu mouse-ul, fără să stricăm click-ul normal pe card. */
(function(){
  var row = document.querySelector('[data-vs-modrow]');
  if (!row) return;
  var isDown = false, moved = false, startX = 0, startScroll = 0;

  row.addEventListener('mousedown', function(e){
    isDown = true; moved = false;
    startX = e.pageX; startScroll = row.scrollLeft;
    row.classList.add('is-dragging');
  });
  window.addEventListener('mouseup', function(){
    isDown = false;
    row.classList.remove('is-dragging');
  });
  window.addEventListener('mouseleave', function(){
    isDown = false;
    row.classList.remove('is-dragging');
  });
  row.addEventListener('mousemove', function(e){
    if (!isDown) return;
    var dx = e.pageX - startX;
    if (Math.abs(dx) > 4) moved = true;
    row.scrollLeft = startScroll - dx;
  });
  // daca a fost drag real, blocheaza click-ul care ar urma (evita deschideri accidentale)
  row.addEventListener('click', function(e){
    if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
  }, true);
})();
// VocalSyrup Hub website demo
document.addEventListener('click',function(e){var b=e.target.closest('[data-hub-tab]');if(!b)return;var hub=b.closest('[data-vs-hub]');if(!hub)return;hub.querySelectorAll('[data-hub-tab]').forEach(function(x){x.classList.toggle('on',x===b)});hub.querySelectorAll('[data-hub-panel]').forEach(function(p){p.classList.toggle('on',p.getAttribute('data-hub-panel')===b.getAttribute('data-hub-tab'))});});
/* VocalSyrup v108: safe product gallery. No content is hidden if JS fails. */
/* v125: added a progress fill (mirrors the hero's module-rail progress bar)
   and prev/next arrow buttons that reuse this exact same activation path
   (dispatching a real click on the target thumb) instead of duplicating
   the swap/scroll logic - one code path, so direct thumb clicks and
   arrow clicks can never fall out of sync with each other. */
(function(){
  function activate(btn){
    var visual=btn.closest('.vsx-story-visual');
    var main=visual&&visual.querySelector('.vsx-story-main');
    if(!main)return;
    var all=visual.querySelectorAll('[data-vs-shot]');
    visual.querySelectorAll('[data-vs-shot]').forEach(function(b){b.classList.toggle('is-active',b===btn)});
    var src=btn.getAttribute('data-vs-shot');
    if(src&&main.getAttribute('src')!==src){
      main.classList.add('is-swapping');
      window.setTimeout(function(){main.src=src;main.classList.remove('is-swapping')},90);
    }
    var fill=visual.querySelector('#vsx-story-progress-fill');
    if(fill){
      var idx=Array.prototype.indexOf.call(all,btn);
      fill.style.transform='scaleX('+((idx+1)/all.length)+')';
    }
    var row=btn.closest('.vsx-story-thumbs');
    if(row&&row.scrollTo){
      row.scrollTo({left:Math.max(0,btn.offsetLeft-(row.clientWidth-btn.offsetWidth)/2),behavior:(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)?'auto':'smooth'});
    }
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('[data-vs-shot]');
    if(btn){activate(btn);return;}
    var nav=e.target.closest&&e.target.closest('[data-vs-nav]');
    if(!nav)return;
    var visual=nav.closest('.vsx-story-visual');
    if(!visual)return;
    var all=Array.prototype.slice.call(visual.querySelectorAll('[data-vs-shot]'));
    var curIdx=all.findIndex(function(b){return b.classList.contains('is-active')});
    if(curIdx<0)curIdx=0;
    var dir=parseInt(nav.getAttribute('data-vs-nav'),10)||1;
    var nextIdx=(curIdx+dir+all.length)%all.length;
    activate(all[nextIdx]);
  });
})();
